import {
    MdBatteryCharging80,
    MdDataSaverOff,   
    MdEqualizer,
    MdMap,
    MdOpacity,
    MdShowChart,
    MdTextFormat,
    MdToggleOff,
    MdDashboard,
  } from "react-icons/md";

  import { AiOutlineAlert } from "react-icons/ai";
  import { BiTable } from "react-icons/bi";
  import { BsThermometerHalf, BsSpeedometer2, BsTable } from "react-icons/bs"
  import { FaWaveSquare } from "react-icons/fa";
  import { ImStatsBars2 } from "react-icons/im";
  
  

  
  
export const WidType = { // estan guardado en Db typeWidgets
    /*
    * widgets permitidos en la plataforma 
    * al 27/02/2025
    */
   
    Barras : "barras",
    Linea : "linea",
    Pasos : "pasos",
    Texto :  "texto",
    Bateria : "bateria",
    Silobolsa : "silobolsa",
    Mapa : "mapa",
    LMove: "move",
    Temperatura: "temperatura",
    Tanque: "tanque", // 10
    Gauge: "gauge",
    Tabla:  "tabla",
    Agrupados: "agrupados",
    OnOff : "onoff",   //14
    Alarma : "alarma", // 15
    Panel: "panel", // 16
    Puente: "puente", // 17

    /*
    * Widgets no implementados
    */
    Calor : "calor",
    Casa : "casa",
    Clima : "clima",
    Conexion : "conexion",
    Departamento : "departamento",
    Flora : "flora",
    Frio : "frio",
    Histograma : "histograma",
    Importante : "importante",
    Luz : "luz",
    Mascota : "mascota",
    Nivel : "nivel",
    Puerta : "puerta",
    Reloj : "reloj",
    Sonido : "sonido",
    Tranquera : "tranquera",
}

/* 
* Lista de widgets permitidos 
* al crear Modelo
*/
export const WidgetsPermitidosModelo = [
    WidType.Barras,
    WidType.Linea,
    WidType.Pasos,
    WidType.Texto,
    WidType.Bateria,
    WidType.Silobolsa ,
    WidType.Mapa,
    WidType.LMove,
    WidType.Temperatura,
    WidType.Tanque,
    WidType.Gauge,
    WidType.Tabla,
    WidType.Agrupados, 
    WidType.OnOff,
    WidType.Alarma,
    WidType.Panel,
    WidType.Puente    
]

// funcion utilizada para dar adaptabilidad a nuevos widgets en desarrollo
export const  WidInfo = (name)=>{
    return WidData[name] || [name,name,MdDataSaverOff]
}

const WidData = {
    [WidType.Barras] : ["Gráfico de Barras", "Ideal para visualizar información histórica.", MdEqualizer],
    [WidType.Linea] : ["Gráfico de Lineas","Ideal para visualizar información histórica.",MdShowChart],   
    [WidType.Pasos] : ["Gráfico de Pasos","Ideal para visualizar información histórica.",FaWaveSquare],   
    [WidType.Texto] : ["Texto","Muestra en formato texto la información que envía su dispositivo",MdTextFormat],   
    [WidType.Bateria] : ["Bateria","Visualice el nivel de batería de su dispositivo", MdBatteryCharging80],   
    [WidType.Mapa] : ["Mapa","Visualice la ubicación de su dispositivo", MdMap],   
    [WidType.LMove] : ["Gráfico de Movimiento","Grafico específico para Agrolink L-Move", ImStatsBars2],   
    [WidType.Temperatura] : ["Temperatura"," Ideal para visualizar temperaturas", BsThermometerHalf],   
    [WidType.Tanque] : ["Tanque","Ideal para visualizar niveles de sólidos o líquidos", MdOpacity],   
    [WidType.Gauge] : ["Gauge","Ideal para indicar valores dentro de un rango", BsSpeedometer2],   
    [WidType.Tabla] : ["Tabla","Visualice los datos de movimiento", BiTable],   
    [WidType.Agrupados] : ["Agrupados","Ideal para mostrar información de un subgrupo de dispositivos", BsTable],   
    [WidType.OnOff] : ["On Off", "Ideal para mostrar información en dos estados 0 y 1",MdToggleOff],
    [WidType.Alarma] : ["Alarma", "Nos muestra una alarma y su estado",AiOutlineAlert],   
    [WidType.Panel] : ["Panel", "Ideal para agrupar un conjunto de comandos",MdDashboard],
    [WidType.Puente] : ["Puente", "Ideal para visualizar nivel de agua",BsTable],
}
